// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"w6WTPF","animatedgradient":"kQ0pp8"};